<template>
  <NewsCard
    description="Klik op de button om een item toe te voegen."
    featured
    :image="require('@/assets/img/events/meeting.webp')"
    name="Item toevoegen"
  />

  <NewsCard
    v-for="item in newsItems"
    :key="item.id"
    :description="item.description"
    :news-item-id="item.id"
    :image="item.visualImage"
    :name="item.title"
    :publish-date-time="item.publishDate"
    :reaction-count="item.reactionCount"
    :read-count="item.readCount"
  />
</template>

<script>
import setRouteNameForModule from '@/helpers/route-name';
import { getAll } from '@/api/providers/news';
import NewsCard from '@/components/News/Card.vue';

export default {
  name: 'NewsIndex',

  components: {
    NewsCard,
  },

  data: () => ({
    newsItems: [],
  }),

  beforeMount() {
    setRouteNameForModule('News', 'Overzicht')
  },

  mounted() {
    this.loadNewsItems();
  },

  methods: {
    loadNewsItems() {
      getAll()
        .then((newsItems) => {
          this.newsItems = newsItems
        })
        .catch((error) => { if (error.default !== undefined) error.default(); });
    },
  },
};
</script>
